<script setup lang="ts">
import { usePartnerStore } from '@/stores/usePartnerStore'
import { storeToRefs } from 'pinia'
import { getCodeNafWithLibelle } from '@/utils/code-naf'
import ButtonDaisy from '@/components/common/buttons/ButtonDaisy.vue'
import { useToast } from 'vue-toast-notification'
import { ArrowPathIcon } from '@heroicons/vue/24/outline'

const partnerStore = usePartnerStore()

const { partner, loading } = storeToRefs(partnerStore)
const $toast = useToast()

async function updatePartner() {
  if (!partner.value) return
  await partnerStore.updateAutoByPartnerId(partner.value.id)
  $toast.success('Mise a jour effectuée')
}
</script>

<template>
  <div v-if="partner" class="w-fit">
    <p><strong>Adresse :</strong> {{ partner.street }} {{ partner.zip }} {{ partner.city }}</p>
    <p><strong>Fixe :</strong> {{ partner.phone || '' }}</p>
    <p><strong>Mobile :</strong> {{ partner.mobile || '' }}</p>
    <p><strong>NAF :</strong> {{ getCodeNafWithLibelle(partner.nafCode) || '' }}</p>
    <p><strong>Nombre d'employés :</strong> {{ partner.companyWorkforce || '' }}</p>
    <p><strong>CA :</strong> {{ partner.xCa || '' }}</p>
    <div class="tooltip tooltip-right" data-tip="Mettre à jour">
      <button-daisy
        :loader="loading"
        text=""
        :icon="ArrowPathIcon"
        class="my-2"
        @click="updatePartner"
        v-if="partner.siret"
      />
    </div>
  </div>
</template>
